module.exports = __webpack_public_path__ + "static/media/logo.9bb8c009.svg";